// Utilities
import { qs, qsa, cls } from "./util/dom-utils";
import pubsub from './util/pubsub';

const getParameterByName = (name, url) => {
	if (!url) {
		url = window.location.href;
	}

	name = name.replace(/[[\]]/g, '\\$&');

	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) {
		return null;
	}
	if (!results[2]) {
		return '';
	}

	return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

// vars
let _lightbox;

class Lightbox {
	constructor($el) {
		this.$el = $el;
		this.$children = qs('.lightbox-container > div');
		this.$close = qs('.js-lightbox-close');
		this.$contents = qs('.lightbox-contents');

		this.$externalLinks = qsa('.js-external-link');
		this.isVisible = false;

		this.clsVisible = 'is-visible';
		this.clsDisableClose = 'disable-close';

		if (this.$el.length) {
			this.isVisible = true;
		}

		this.hideHandler = this.hideHandler.bind(this);
		this.attachEvents();

		if ( getParameterByName('findADoctor') ) {
			// call find a doctor popup
			cls.add(this.$el, this.clsVisible);
			cls.add(qs('.js-lightbox-healthengine',this.$el), this.clsVisible);
		}
	}

	attachEvents() {
		this.$close.addEventListener('click', () => {
			this.hideHandler();
		});

		this.$el.addEventListener('click', () => {
			if (!cls.has(this.$el, this.clsDisableClose)) {
				this.hideHandler();
			}
		});

		this.$externalLinks.forEach(el => {
			el.addEventListener('click', this.hideHandler);
		});

		this.$contents.addEventListener('click', (evt) => {
			evt.stopPropagation();
		});

		document.addEventListener('keyup', (e) => {
			if (this.isVisible && (e.key === 'Escape')) {
				this.hideHandler();
			}
		});
	}

	openLightboxByName(name) {
		const currentTarget = document.createElement('div');
		currentTarget.setAttribute('data-lightbox', name);
		this.showHandler({currentTarget});
	}

	showHandler(target) {

		let currentTarget = target;
		let $target = currentTarget.getAttribute('data-lightbox');

		if($target === 'leavesite') {
			let $externalHyp = currentTarget.getAttribute('href');
			if($externalHyp){

				qs('.js-external-link', qs('.js-lightbox-' + $target)).setAttribute('href', $externalHyp);
			}
		}

		if(cls.has(this.$el,this.clsVisible)) {
			const $target = qsa('div.is-visible', this.$el);
			$target.forEach(el => {
				cls.remove(el, this.clsVisible);
			});
		}

		if ($target) {
			cls.add(this.$el, this.clsVisible);
			cls.add(qs('.js-lightbox-' + $target, this.$el), this.clsVisible);
		}
	}

	hideHandler() {
		const $target = qsa('div.is-visible', this.$el);
		
		$target.forEach(el => {
			cls.remove(el, this.clsVisible);
		});

		cls.remove(this.$el, this.clsVisible);
		cls.remove(this.$children, this.clsVisible);

		$target.forEach(el => {
			if (cls.has(el, 'js-lightbox-healthengine')) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'custom.event.footer_lightbox_close'
				});
			}
		});

		pubsub.publish('LIGHTBOX_CLOSE', $target);
	}
}

export default _lightbox;

const _init = () => {

	// Elements
	let $el = qs('.js-lightbox');
	let $cta = qsa('[data-lightbox]');

	const _lightbox = new Lightbox($el);

	if ($cta.length) {
		$cta.forEach(el => {
			el.addEventListener('click', (evt)=> {
				evt.preventDefault();
				_lightbox.showHandler(el);	
			});
		});
	}

};

_init();
